module.exports = __webpack_public_path__ + "media/images/login/demo_btn-2a134f60192e1e0c3ca67483fcf28028.png";